import { __assign, __read } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import Popup from '@atlaskit/popup';
import WidthDetector from '@atlaskit/width-detector';
import { useCallback, useState } from 'react';
import { useOverflowController, OverflowProvider, } from '../../controllers/overflow';
import { PrimaryDropdownButton } from '../PrimaryDropdownButton';
import { containerCSS, widthDetectorContainerStyle } from './styles';
export var PrimaryItemsContainer = function (_a) {
    var moreLabel = _a.moreLabel, items = _a.items, Create = _a.create, theme = _a.theme, testId = _a.testId;
    var _b = __read(useState(false), 2), isMoreOpen = _b[0], setIsMoreOpen = _b[1];
    var _c = useOverflowController(items), updateWidth = _c.updateWidth, visibleItems = _c.visibleItems, overflowItems = _c.overflowItems;
    var onMoreClick = useCallback(function () {
        setIsMoreOpen(!isMoreOpen);
    }, [isMoreOpen, setIsMoreOpen]);
    var onMoreClose = useCallback(function () {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = useCallback(function () {
        setIsMoreOpen(true);
    }, []);
    var trigger = useCallback(function (triggerProps) { return (jsx(PrimaryDropdownButton, __assign({ onClick: onMoreClick, isSelected: isMoreOpen, testId: testId ? testId + "-overflow-menu-trigger" : 'overflow-menu-trigger' }, triggerProps), moreLabel)); }, [moreLabel, onMoreClick, isMoreOpen, testId]);
    var content = useCallback(function () { return (jsx(OverflowProvider, { isVisible: false, openOverflowMenu: openOverflowMenu, closeOverflowMenu: onMoreClose }, overflowItems)); }, 
    // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [overflowItems.length, openOverflowMenu, onMoreClose]);
    return (jsx("div", { css: containerCSS(theme), "data-testid": testId && testId + "-primary-actions" },
        jsx(OverflowProvider, { isVisible: true, openOverflowMenu: openOverflowMenu, closeOverflowMenu: onMoreClose }, visibleItems),
        overflowItems.length > 0 && (jsx(Popup, { placement: "bottom-start", content: content, isOpen: isMoreOpen, onClose: onMoreClose, trigger: trigger, testId: testId ? testId + "-overflow-menu-popup" : 'overflow-menu-popup' })),
        Create && jsx(Create, null),
        jsx(WidthDetector, { containerStyle: widthDetectorContainerStyle, onResize: updateWidth }, function () { return null; })));
};
//# sourceMappingURL=index.js.map